/**
 * Static feed content for the public Trending tab. GetFeeds requires auth, so
 * anonymous visitors see this teaser until an anonymous trending API exists;
 * signed-in members always get live feeds via FeedContext.
 */
import type { FeedPost } from '@wlb/shared/types/post';
import avatarSarah from '../../assets/images/trending/avatar-sarah.png';
import avatarBuddy from '../../assets/images/trending/avatar-buddy.png';
import postWalk from '../../assets/images/trending/post-walk.png';
/** The design export for these two cards is an empty 1x1 transparent PNG; it is
 *  bundled as-is so the teaser renders exactly as it did from the CDN. */
import postPlaceholder from '../../assets/images/trending/post-placeholder.png';

export const STATIC_TRENDING_POSTS: FeedPost[] = [
  {
    id: 'static-1',
    username: 'Sarah Miller',
    avatar: avatarSarah,
    timeAgo: '2h',
    text: 'Down 4 lbs this month! Daily walks after dinner and tracking everything I eat. Small habits really add up.',
    image: { uri: postWalk },
    likes: 128,
    comments: 23,
    shares: 0,
    saved: false,
    liked: false,
  },
  {
    id: 'static-2',
    username: 'James Carter',
    avatar: avatarBuddy,
    timeAgo: '5h',
    text: 'Meal prep Sunday done. Grilled chicken, quinoa, roasted veggies — lunches sorted for the whole week.',
    image: { uri: postPlaceholder },
    likes: 96,
    comments: 17,
    shares: 0,
    saved: false,
    liked: false,
  },
  {
    id: 'static-3',
    username: 'Priya Shah',
    avatar: avatarBuddy,
    timeAgo: '8h',
    text: 'Hit my 10k steps goal every day this week. First time ever! The streak badge is oddly motivating.',
    image: { uri: postPlaceholder },
    likes: 74,
    comments: 11,
    shares: 0,
    saved: false,
    liked: false,
  },
  {
    id: 'static-4',
    username: 'Marcus Lee',
    avatar: null,
    timeAgo: '1d',
    text: 'Reminder: the scale is only one data point. Energy levels, sleep, and how your clothes fit matter just as much.',
    likes: 210,
    comments: 42,
    shares: 0,
    saved: false,
    liked: false,
  },
];
